"use client";

import { useState } from "react";
import { DataSourceDetails } from "@/components/documents/cards/datasource-details-card";
import { DatasourceList } from "@/components/documents/cards/datasource-list";

export function DataSourceTab() {
  const [activeSection, setActiveSection] = useState("list");
  const [selectedDataSource, setSelectedDataSource] = useState<DataSource | null>(null);

  if (activeSection === "details" && selectedDataSource) {
    return (
      <DataSourceDetails
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        datasource={selectedDataSource}
        onViewGroups={() => { }}
      />
    );
  }

  return (
    <div >
      {activeSection === "list" && (
        <DatasourceList
          setActiveSection={setActiveSection}
          setSelectedDataSource={(ds) => setSelectedDataSource(ds)}
        />
      )}
    </div>
  );
}
